import Service from "./Service"

class NoteService extends Service {

    findById = (id) => this.get(`/notes/${id}`)

    findAll = (queryParams) => this.getWithParams("/notes", queryParams)

    createNote = (request) => this.post("/notes", request)

    updateNote = (id, request) => this.patch(`/notes/${id}`, request)

    deleteNote = (id) => this.del(`/notes/${id}`)
}

const noteService = new NoteService()
export default noteService